export default "__VITE_ASSET__Col3NjvE__"